import { useEffect, useRef, useState } from 'react'
import { exportButtons, NAMESPACE } from '../utils'
import { SvgExportIconBlue, SvgPdfIconDownload } from '../assets/images'
import myImage from '../icons/common/csv.png'
import excelIcon from '../icons/common/excel-icon.png'
import Tooltip from './Tooltip'
import SvgExportClicked from '../assets/images/components/SvgExportClicked'

const ExportButtonDropdown = ({ ...props }) => {
  const [isOpen, setIsOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)
  const [clicked, setClicked] = useState(false)
  const toggleDropdown = () => {
    if (!props?.disabled) {
      setIsOpen(!isOpen)
    }
  }

  const handleExportOption = (option: string) => {
    if (props?.onExportOption) {
      props?.onExportOption(option)
    }
    setIsOpen(false)
    setClicked(false)
  }
  let IconComponent
  if (props?.disabled) {
    IconComponent = <SvgExportIconBlue className="svg-path-fill-accent-200" />
  } else if (clicked) {
    IconComponent = <SvgExportClicked />
  } else {
    IconComponent = <SvgExportIconBlue />
  }

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsOpen(false)
        setClicked(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      className={`flex items-center text-center ${props.className}`}
      ref={dropdownRef}
      onClick={toggleDropdown}
    >
      <div className="relative inline-block text-left">
        {/* Export Button */}
        <Tooltip
          content={NAMESPACE.EXPORT}
          position="bottom"
          cssClassName="flex items-center"
        >
          <button
            data-qa-id={props?.dataQaId}
            className={`inline-flex h-7 items-center text-xs font-medium rounded-md ${
              props?.disabled
                ? 'text-accent-500 cursor-not-allowed'
                : 'border-border-150'
            }`}
            disabled={props?.disabled}
            type="button"
            onClick={() => setClicked((prev) => !prev)} // Toggle state on click
          >
            {IconComponent}
          </button>
        </Tooltip>

        {/* Dropdown Menu */}
        {isOpen &&
          (props?.showCSV || props?.showExcel || props?.showPDF) &&
          clicked && (
            <div
              className={`absolute z-20 origin-top-right rounded-md bg-accent-0 ring-1 ring-black ring-opacity-5 w-[7.7rem] top-[2.7rem] ${props?.customCSS}`}
            >
              <div className="py-1">
                {props?.showCSV && (
                  <button
                    className="w-full text-left px-4 py-2 text-xs font-primary font-medium text-accent-700 hover:bg-accent-100"
                    onClick={() => handleExportOption(exportButtons.CSV)}
                  >
                    <span className="flex gap-3 justify-start">
                      <img src={myImage} alt="csv" height={24} width={24} />
                      {exportButtons.CSV}
                    </span>
                  </button>
                )}
                {props?.showExcel && (
                  <button
                    className="w-full text-left px-4 py-2 text-xs font-primary font-medium text-accent-700 hover:bg-accent-100"
                    onClick={() => handleExportOption(exportButtons.EXCEL)}
                  >
                    <span className="flex gap-3 justify-start">
                      <img src={excelIcon} alt="excel" />
                      {exportButtons.EXCEL}
                    </span>
                  </button>
                )}
                {props?.showPDF && (
                  <button
                    className="w-full text-left px-4 py-2 text-xs font-primary font-medium text-accent-700 hover:bg-accent-100"
                    onClick={() => handleExportOption(exportButtons.PDF)}
                  >
                    <span className="flex gap-3 justify-start">
                      <SvgPdfIconDownload />
                      {exportButtons.PDF}
                    </span>
                  </button>
                )}
              </div>
            </div>
          )}
      </div>
    </div>
  )
}

export default ExportButtonDropdown
